var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMenuWholesaleInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3150_27728)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.60095 1H12.7828C13.1098 1 13.3852 1.26681 13.3852 1.60247C13.3852 1.92953 13.1184 2.20495 12.7828 2.20495H2.60095C2.27389 2.20495 1.99847 1.93814 1.99847 1.60247C1.99847 1.27542 2.26528 1 2.60095 1Z",
    stroke: "#1E1E1E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9705 3.20496H3.79729C2.80383 3.20496 1.99847 4.01031 1.99847 5.00377V12.7843C1.99847 13.7778 2.80383 14.5831 3.79729 14.5831H13.9705C14.964 14.5831 15.7693 13.7778 15.7693 12.7843V5.00377C15.7693 4.01031 14.964 3.20496 13.9705 3.20496Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2192 6.53308H1.54865",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2192 10.2152H1.54865",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3150_27728"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.7708,
    height: 15.5831,
    fill: "white",
    transform: "translate(0.998474)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuWholesaleInactive);
export default __webpack_public_path__ + "static/media/Icon-Menu_Wholesale_Inactive.b9e460b0f696c1ee408b73f3a464f46b.svg";
export { ForwardRef as ReactComponent };